const module = { name: 'shared/utils/hearts', exports: {} }; const exports = module.exports;



import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from 'require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango as fdData } from 'require-core';



import { Fandango_favoriteFlyout as flyout } from 'base-libraries';



import { fd_url_manager as links } from 'require-core';



import { Fandango_sanitizer as sanitizer } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';



const { isLoggedIn, theaterDetails, isTDP } = readPageContext(fdData)


const Selectors = {
    HEARTS: '.js-hearts-heart',
    ARIA_LIVE: '#js-hearts-aria-live'
}


const Styles = {
    IS_FAVORITE: 'icon-fave-heart--filled',
    IS_FAVORITE_MEDIUM: 'icon-fave-heart--medium-filled',
    IS_FAVORITE_BUTTON: 'movie-detail-header__list-btn--favorite',
    NOT_FAVORITE_MEDIUM: 'icon-fave-heart--medium-white-outline',
    NOT_FAVORITE_MEDIUM_GRAY: 'icon-fave-heart--medium-gray-outline',
    NOT_FAVORITE_OUTLINE: 'icon-fave-heart--white-outline',
    NOT_FAVORITE_BUTTON: 'movie-detail-header__list-btn',
}


const Actions = {
    MOVIE_SAVED: 'movie-saved',
    MOVIE_DELETED: 'movie-deleted',
    THEATER_SAVED: 'theater-saved',
    THEATER_DELETED: 'theater-deleted',
    REMOVED: 'removed from',
    ADDED: 'added to'
}


const DataAttr = {
    ID: 'id',
    IS_FAVORITE: 'isFavorite',
    TYPE: 'type',
    ICON_STYLE: 'iconStyle'
}


const RegExes = {
    BTN_TEXT: /(Remove from|Add to)/i
}


const sessionStorageId = 'favoritedInfo'


let clickedHeart
function readPageContext(fdData) {
    const { context: { theater }, account, pageDetails } = fdData;
    return {
        isLoggedIn: Boolean(account?.isLoggedIn),
        theaterDetails: theater?.details || {},
        isTDP: Boolean(pageDetails?.isTDP),
    };
}
function updateAria(isFavorite) {
    const ariaLiveArea = document.querySelector(Selectors.ARIA_LIVE);
    if (!ariaLiveArea) {
        return;
    }
    ariaLiveArea.textContent = '';
    ariaLiveArea.textContent = isFavorite
        ? 'Cinema is saved to favorites.'
        : 'Save cinema to favorites.';
}
function setHeartState(heartEl, isFavorite) {
    heartEl.dataset[DataAttr.IS_FAVORITE] = isFavorite;
    const useGrayIcons = heartEl.dataset[DataAttr.ICON_STYLE] === 'gray';
    const useButtonIcons = heartEl.dataset[DataAttr.ICON_STYLE] === 'button';
    let favStyle;
    let notFavStyle;
    if (isTDP) {
        favStyle = Styles.IS_FAVORITE_MEDIUM;
        notFavStyle = useGrayIcons ? Styles.NOT_FAVORITE_MEDIUM_GRAY : Styles.NOT_FAVORITE_MEDIUM;
    }
    else {
        if (useButtonIcons) {
            favStyle = Styles.IS_FAVORITE_BUTTON;
            notFavStyle = Styles.NOT_FAVORITE_BUTTON;
        }
        else {
            favStyle = Styles.IS_FAVORITE;
            notFavStyle = Styles.NOT_FAVORITE_OUTLINE;
        }
    }
    heartEl.classList.add(isFavorite ? favStyle : notFavStyle);
    heartEl.classList.remove(isFavorite ? notFavStyle : favStyle);
    const text = heartEl.innerText;
    if (useButtonIcons) {
        heartEl.innerText = (isFavorite ? 'Added to ' : '') + 'List';
    }
    else if (text && RegExes.BTN_TEXT.test(text)) {
        heartEl.innerText = text.replace(RegExes.BTN_TEXT, isFavorite ? 'Remove from' : 'Add to');
    }
}
function checkForSessionStorage() {
    const storedData = sessionStorage.getItem(sessionStorageId);
    if (!storedData || !isLoggedIn) {
        return;
    }
    try {
        const data = JSON.parse(storedData);
        if ((data.type === 'Movie') || (data.type === 'Theater')) {
            const id = sanitizer.id(data.id);
            clickedHeart = document.querySelector(`${Selectors.HEARTS}[data-id="${id}"]`);
            if (!clickedHeart) {
                return;
            }
            setHeartState(clickedHeart, !data.isFavorite);
            sessionStorage.removeItem(sessionStorageId);
            postHeart(data);
        }
    }
    catch (e) {
        sessionStorage.removeItem(sessionStorageId);
    }
}
function onPostFail(err) {
    if (err) {
        flyout.showFlyout({}, 'error', {});
    }
}
function onPostHeartDone(data) {
    if (!data || data.message !== 'Success') {
        return flyout.showFlyout({}, 'error', {});
    }
    switch (data.type) {
        case Actions.MOVIE_SAVED:
        case Actions.THEATER_SAVED:
            flyout.showFlyout(clickedHeart, Actions.ADDED, data.type);
            break;
        case Actions.MOVIE_DELETED:
        case Actions.THEATER_DELETED:
            flyout.showFlyout(clickedHeart, Actions.REMOVED, data.type);
            break;
    }
}
function postHeart(data) {
    data = {
        isFavorite: sanitizer.boolean(data.isFavorite),
        id: sanitizer.id(data.id),
        type: sanitizer.text(data.type)
    };
    const url = links.napiFavorites({
        type: data.type,
        id: data.id
    });
    xhr.ajax({
        url,
        method: data.isFavorite ? 'DELETE' : 'POST',
        data,
        timeout: 7000,
    })
        .done(onPostHeartDone)
        .fail(onPostFail);
}
function getHeartData(elem) {
    return {
        isFavorite: elem.dataset[DataAttr.IS_FAVORITE] === 'true',
        id: elem.dataset[DataAttr.ID],
        type: elem.dataset[DataAttr.TYPE]
    };
}
function onClick(event) {
    clickedHeart = event.currentTarget;
    const data = getHeartData(clickedHeart);
    if (isLoggedIn) {
        event.preventDefault();
        setHeartState(clickedHeart, !data.isFavorite);
        postHeart(data);
        updateAria(!data.isFavorite);
    }
    else {
        try {
            sessionStorage.setItem(sessionStorageId, JSON.stringify(data));
        }
        catch (e) {
            console.warn('Failed to save to sessionStorage:', e);
        }
    }
    track({
        event: EventTypes.FAVORITE_THEATER_CLICKS,
        theaterName: theaterDetails.name,
        exhibitor: theaterDetails.exhibitor,
        theaterID: theaterDetails.id
    });
}
function init() {
    checkForSessionStorage();
    $(document).off('click', Selectors.HEARTS, onClick).on('click', Selectors.HEARTS, onClick);
}
module.exports = {
    init,
    run: init,
};
export default module.exports;